export const appsMultiLanguageSettingsValidateTranslationUsage =
  "/apps/multi_language_settings/validate_translation_usage" as const;
